/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UiSandboxRouteImport } from './routes/ui-sandbox'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthVerifySignInRouteImport } from './routes/_auth/verify-sign-in'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AuthTwoFactorRouteImport } from './routes/_auth/two-factor'
import { Route as AuthSsoCallbackRouteImport } from './routes/_auth/sso-callback'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppDebugDataRouteImport } from './routes/_app/debug-data'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppOriginsIndexRouteImport } from './routes/_app/origins/index'
import { Route as AppMonitorsIndexRouteImport } from './routes/_app/monitors/index'
import { Route as AppHelpIndexRouteImport } from './routes/_app/help/index'
import { Route as AppDocsIndexRouteImport } from './routes/_app/docs/index'
import { Route as AppSettingsWorkspaceRouteImport } from './routes/_app/settings/workspace'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings/security'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings/profile'
import { Route as AppSettingsMembersRouteImport } from './routes/_app/settings/members'
import { Route as AppSettingsKeysRouteImport } from './routes/_app/settings/keys'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/_app/settings/integrations'
import { Route as AppSettingsDangerRouteImport } from './routes/_app/settings/danger'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/settings/billing'
import { Route as AppMonitorsNewRouteImport } from './routes/_app/monitors/new'
import { Route as AppDocsWebhooksRouteImport } from './routes/_app/docs/webhooks'
import { Route as AppDocsSdksRouteImport } from './routes/_app/docs/sdks'
import { Route as AppDocsQuickstartRouteImport } from './routes/_app/docs/quickstart'
import { Route as AppDocsChangelogRouteImport } from './routes/_app/docs/changelog'
import { Route as AppDocsApiRouteImport } from './routes/_app/docs/api'
import { Route as AppCliAuthorizeRouteImport } from './routes/_app/cli/authorize'
import { Route as AppSettingsWebhooksIndexRouteImport } from './routes/_app/settings/webhooks/index'
import { Route as AppSettingsLogsIndexRouteImport } from './routes/_app/settings/logs/index'
import { Route as AppOriginsSiteUuidIndexRouteImport } from './routes/_app/origins/$siteUuid/index'
import { Route as AppSettingsWebhooksNewRouteImport } from './routes/_app/settings/webhooks/new'
import { Route as AppSettingsLogsAuditIdRouteImport } from './routes/_app/settings/logs/$auditId'
import { Route as AppSettingsWebhooksUuidEditRouteImport } from './routes/_app/settings/webhooks/$uuid/edit'
import { Route as AppSettingsWebhooksUuidDeliveriesRouteImport } from './routes/_app/settings/webhooks/$uuid/deliveries'
import { Route as AppOriginsSiteUuidPagesPageUuidRouteImport } from './routes/_app/origins/$siteUuid/pages/$pageUuid'

const UiSandboxRoute = UiSandboxRouteImport.update({
  id: '/ui-sandbox',
  path: '/ui-sandbox',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthVerifySignInRoute = AuthVerifySignInRouteImport.update({
  id: '/verify-sign-in',
  path: '/verify-sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTwoFactorRoute = AuthTwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSsoCallbackRoute = AuthSsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppDebugDataRoute = AppDebugDataRouteImport.update({
  id: '/debug-data',
  path: '/debug-data',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppOriginsIndexRoute = AppOriginsIndexRouteImport.update({
  id: '/origins/',
  path: '/origins/',
  getParentRoute: () => AppRoute,
} as any)
const AppMonitorsIndexRoute = AppMonitorsIndexRouteImport.update({
  id: '/monitors/',
  path: '/monitors/',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpIndexRoute = AppHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsIndexRoute = AppDocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsWorkspaceRoute = AppSettingsWorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsKeysRoute = AppSettingsKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDangerRoute = AppSettingsDangerRouteImport.update({
  id: '/danger',
  path: '/danger',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppMonitorsNewRoute = AppMonitorsNewRouteImport.update({
  id: '/monitors/new',
  path: '/monitors/new',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsWebhooksRoute = AppDocsWebhooksRouteImport.update({
  id: '/docs/webhooks',
  path: '/docs/webhooks',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsSdksRoute = AppDocsSdksRouteImport.update({
  id: '/docs/sdks',
  path: '/docs/sdks',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsQuickstartRoute = AppDocsQuickstartRouteImport.update({
  id: '/docs/quickstart',
  path: '/docs/quickstart',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsChangelogRoute = AppDocsChangelogRouteImport.update({
  id: '/docs/changelog',
  path: '/docs/changelog',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsApiRoute = AppDocsApiRouteImport.update({
  id: '/docs/api',
  path: '/docs/api',
  getParentRoute: () => AppRoute,
} as any)
const AppCliAuthorizeRoute = AppCliAuthorizeRouteImport.update({
  id: '/cli/authorize',
  path: '/cli/authorize',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsWebhooksIndexRoute =
  AppSettingsWebhooksIndexRouteImport.update({
    id: '/webhooks/',
    path: '/webhooks/',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsLogsIndexRoute = AppSettingsLogsIndexRouteImport.update({
  id: '/logs/',
  path: '/logs/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppOriginsSiteUuidIndexRoute = AppOriginsSiteUuidIndexRouteImport.update({
  id: '/origins/$siteUuid/',
  path: '/origins/$siteUuid/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsWebhooksNewRoute = AppSettingsWebhooksNewRouteImport.update({
  id: '/webhooks/new',
  path: '/webhooks/new',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsLogsAuditIdRoute = AppSettingsLogsAuditIdRouteImport.update({
  id: '/logs/$auditId',
  path: '/logs/$auditId',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsWebhooksUuidEditRoute =
  AppSettingsWebhooksUuidEditRouteImport.update({
    id: '/webhooks/$uuid/edit',
    path: '/webhooks/$uuid/edit',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsWebhooksUuidDeliveriesRoute =
  AppSettingsWebhooksUuidDeliveriesRouteImport.update({
    id: '/webhooks/$uuid/deliveries',
    path: '/webhooks/$uuid/deliveries',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppOriginsSiteUuidPagesPageUuidRoute =
  AppOriginsSiteUuidPagesPageUuidRouteImport.update({
    id: '/origins/$siteUuid/pages/$pageUuid',
    path: '/origins/$siteUuid/pages/$pageUuid',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/onboarding': typeof OnboardingRoute
  '/ui-sandbox': typeof UiSandboxRoute
  '/debug-data': typeof AppDebugDataRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/sso-callback': typeof AuthSsoCallbackRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/verify-sign-in': typeof AuthVerifySignInRoute
  '/cli/authorize': typeof AppCliAuthorizeRoute
  '/docs/api': typeof AppDocsApiRoute
  '/docs/changelog': typeof AppDocsChangelogRoute
  '/docs/quickstart': typeof AppDocsQuickstartRoute
  '/docs/sdks': typeof AppDocsSdksRoute
  '/docs/webhooks': typeof AppDocsWebhooksRoute
  '/monitors/new': typeof AppMonitorsNewRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/danger': typeof AppSettingsDangerRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/keys': typeof AppSettingsKeysRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/workspace': typeof AppSettingsWorkspaceRoute
  '/docs/': typeof AppDocsIndexRoute
  '/help/': typeof AppHelpIndexRoute
  '/monitors/': typeof AppMonitorsIndexRoute
  '/origins/': typeof AppOriginsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/settings/logs/$auditId': typeof AppSettingsLogsAuditIdRoute
  '/settings/webhooks/new': typeof AppSettingsWebhooksNewRoute
  '/origins/$siteUuid/': typeof AppOriginsSiteUuidIndexRoute
  '/settings/logs/': typeof AppSettingsLogsIndexRoute
  '/settings/webhooks/': typeof AppSettingsWebhooksIndexRoute
  '/origins/$siteUuid/pages/$pageUuid': typeof AppOriginsSiteUuidPagesPageUuidRoute
  '/settings/webhooks/$uuid/deliveries': typeof AppSettingsWebhooksUuidDeliveriesRoute
  '/settings/webhooks/$uuid/edit': typeof AppSettingsWebhooksUuidEditRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/onboarding': typeof OnboardingRoute
  '/ui-sandbox': typeof UiSandboxRoute
  '/debug-data': typeof AppDebugDataRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/sso-callback': typeof AuthSsoCallbackRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/verify-sign-in': typeof AuthVerifySignInRoute
  '/cli/authorize': typeof AppCliAuthorizeRoute
  '/docs/api': typeof AppDocsApiRoute
  '/docs/changelog': typeof AppDocsChangelogRoute
  '/docs/quickstart': typeof AppDocsQuickstartRoute
  '/docs/sdks': typeof AppDocsSdksRoute
  '/docs/webhooks': typeof AppDocsWebhooksRoute
  '/monitors/new': typeof AppMonitorsNewRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/danger': typeof AppSettingsDangerRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/keys': typeof AppSettingsKeysRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/workspace': typeof AppSettingsWorkspaceRoute
  '/docs': typeof AppDocsIndexRoute
  '/help': typeof AppHelpIndexRoute
  '/monitors': typeof AppMonitorsIndexRoute
  '/origins': typeof AppOriginsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/settings/logs/$auditId': typeof AppSettingsLogsAuditIdRoute
  '/settings/webhooks/new': typeof AppSettingsWebhooksNewRoute
  '/origins/$siteUuid': typeof AppOriginsSiteUuidIndexRoute
  '/settings/logs': typeof AppSettingsLogsIndexRoute
  '/settings/webhooks': typeof AppSettingsWebhooksIndexRoute
  '/origins/$siteUuid/pages/$pageUuid': typeof AppOriginsSiteUuidPagesPageUuidRoute
  '/settings/webhooks/$uuid/deliveries': typeof AppSettingsWebhooksUuidDeliveriesRoute
  '/settings/webhooks/$uuid/edit': typeof AppSettingsWebhooksUuidEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/ui-sandbox': typeof UiSandboxRoute
  '/_app/debug-data': typeof AppDebugDataRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_auth/sso-callback': typeof AuthSsoCallbackRoute
  '/_auth/two-factor': typeof AuthTwoFactorRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/_auth/verify-sign-in': typeof AuthVerifySignInRoute
  '/_app/': typeof AppIndexRoute
  '/_app/cli/authorize': typeof AppCliAuthorizeRoute
  '/_app/docs/api': typeof AppDocsApiRoute
  '/_app/docs/changelog': typeof AppDocsChangelogRoute
  '/_app/docs/quickstart': typeof AppDocsQuickstartRoute
  '/_app/docs/sdks': typeof AppDocsSdksRoute
  '/_app/docs/webhooks': typeof AppDocsWebhooksRoute
  '/_app/monitors/new': typeof AppMonitorsNewRoute
  '/_app/settings/billing': typeof AppSettingsBillingRoute
  '/_app/settings/danger': typeof AppSettingsDangerRoute
  '/_app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/_app/settings/keys': typeof AppSettingsKeysRoute
  '/_app/settings/members': typeof AppSettingsMembersRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/settings/workspace': typeof AppSettingsWorkspaceRoute
  '/_app/docs/': typeof AppDocsIndexRoute
  '/_app/help/': typeof AppHelpIndexRoute
  '/_app/monitors/': typeof AppMonitorsIndexRoute
  '/_app/origins/': typeof AppOriginsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/settings/logs/$auditId': typeof AppSettingsLogsAuditIdRoute
  '/_app/settings/webhooks/new': typeof AppSettingsWebhooksNewRoute
  '/_app/origins/$siteUuid/': typeof AppOriginsSiteUuidIndexRoute
  '/_app/settings/logs/': typeof AppSettingsLogsIndexRoute
  '/_app/settings/webhooks/': typeof AppSettingsWebhooksIndexRoute
  '/_app/origins/$siteUuid/pages/$pageUuid': typeof AppOriginsSiteUuidPagesPageUuidRoute
  '/_app/settings/webhooks/$uuid/deliveries': typeof AppSettingsWebhooksUuidDeliveriesRoute
  '/_app/settings/webhooks/$uuid/edit': typeof AppSettingsWebhooksUuidEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/ui-sandbox'
    | '/debug-data'
    | '/settings'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/sso-callback'
    | '/two-factor'
    | '/verify-email'
    | '/verify-sign-in'
    | '/cli/authorize'
    | '/docs/api'
    | '/docs/changelog'
    | '/docs/quickstart'
    | '/docs/sdks'
    | '/docs/webhooks'
    | '/monitors/new'
    | '/settings/billing'
    | '/settings/danger'
    | '/settings/integrations'
    | '/settings/keys'
    | '/settings/members'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/workspace'
    | '/docs/'
    | '/help/'
    | '/monitors/'
    | '/origins/'
    | '/settings/'
    | '/settings/logs/$auditId'
    | '/settings/webhooks/new'
    | '/origins/$siteUuid/'
    | '/settings/logs/'
    | '/settings/webhooks/'
    | '/origins/$siteUuid/pages/$pageUuid'
    | '/settings/webhooks/$uuid/deliveries'
    | '/settings/webhooks/$uuid/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/ui-sandbox'
    | '/debug-data'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/sso-callback'
    | '/two-factor'
    | '/verify-email'
    | '/verify-sign-in'
    | '/cli/authorize'
    | '/docs/api'
    | '/docs/changelog'
    | '/docs/quickstart'
    | '/docs/sdks'
    | '/docs/webhooks'
    | '/monitors/new'
    | '/settings/billing'
    | '/settings/danger'
    | '/settings/integrations'
    | '/settings/keys'
    | '/settings/members'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/workspace'
    | '/docs'
    | '/help'
    | '/monitors'
    | '/origins'
    | '/settings'
    | '/settings/logs/$auditId'
    | '/settings/webhooks/new'
    | '/origins/$siteUuid'
    | '/settings/logs'
    | '/settings/webhooks'
    | '/origins/$siteUuid/pages/$pageUuid'
    | '/settings/webhooks/$uuid/deliveries'
    | '/settings/webhooks/$uuid/edit'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/onboarding'
    | '/ui-sandbox'
    | '/_app/debug-data'
    | '/_app/settings'
    | '/_auth/forgot-password'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_auth/sso-callback'
    | '/_auth/two-factor'
    | '/_auth/verify-email'
    | '/_auth/verify-sign-in'
    | '/_app/'
    | '/_app/cli/authorize'
    | '/_app/docs/api'
    | '/_app/docs/changelog'
    | '/_app/docs/quickstart'
    | '/_app/docs/sdks'
    | '/_app/docs/webhooks'
    | '/_app/monitors/new'
    | '/_app/settings/billing'
    | '/_app/settings/danger'
    | '/_app/settings/integrations'
    | '/_app/settings/keys'
    | '/_app/settings/members'
    | '/_app/settings/profile'
    | '/_app/settings/security'
    | '/_app/settings/workspace'
    | '/_app/docs/'
    | '/_app/help/'
    | '/_app/monitors/'
    | '/_app/origins/'
    | '/_app/settings/'
    | '/_app/settings/logs/$auditId'
    | '/_app/settings/webhooks/new'
    | '/_app/origins/$siteUuid/'
    | '/_app/settings/logs/'
    | '/_app/settings/webhooks/'
    | '/_app/origins/$siteUuid/pages/$pageUuid'
    | '/_app/settings/webhooks/$uuid/deliveries'
    | '/_app/settings/webhooks/$uuid/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
  UiSandboxRoute: typeof UiSandboxRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/ui-sandbox': {
      id: '/ui-sandbox'
      path: '/ui-sandbox'
      fullPath: '/ui-sandbox'
      preLoaderRoute: typeof UiSandboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/verify-sign-in': {
      id: '/_auth/verify-sign-in'
      path: '/verify-sign-in'
      fullPath: '/verify-sign-in'
      preLoaderRoute: typeof AuthVerifySignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/two-factor': {
      id: '/_auth/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof AuthTwoFactorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sso-callback': {
      id: '/_auth/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof AuthSsoCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/debug-data': {
      id: '/_app/debug-data'
      path: '/debug-data'
      fullPath: '/debug-data'
      preLoaderRoute: typeof AppDebugDataRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/origins/': {
      id: '/_app/origins/'
      path: '/origins'
      fullPath: '/origins/'
      preLoaderRoute: typeof AppOriginsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/monitors/': {
      id: '/_app/monitors/'
      path: '/monitors'
      fullPath: '/monitors/'
      preLoaderRoute: typeof AppMonitorsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/': {
      id: '/_app/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof AppHelpIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/': {
      id: '/_app/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof AppDocsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/workspace': {
      id: '/_app/settings/workspace'
      path: '/workspace'
      fullPath: '/settings/workspace'
      preLoaderRoute: typeof AppSettingsWorkspaceRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/members': {
      id: '/_app/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/keys': {
      id: '/_app/settings/keys'
      path: '/keys'
      fullPath: '/settings/keys'
      preLoaderRoute: typeof AppSettingsKeysRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/integrations': {
      id: '/_app/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/danger': {
      id: '/_app/settings/danger'
      path: '/danger'
      fullPath: '/settings/danger'
      preLoaderRoute: typeof AppSettingsDangerRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/billing': {
      id: '/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/monitors/new': {
      id: '/_app/monitors/new'
      path: '/monitors/new'
      fullPath: '/monitors/new'
      preLoaderRoute: typeof AppMonitorsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/webhooks': {
      id: '/_app/docs/webhooks'
      path: '/docs/webhooks'
      fullPath: '/docs/webhooks'
      preLoaderRoute: typeof AppDocsWebhooksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/sdks': {
      id: '/_app/docs/sdks'
      path: '/docs/sdks'
      fullPath: '/docs/sdks'
      preLoaderRoute: typeof AppDocsSdksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/quickstart': {
      id: '/_app/docs/quickstart'
      path: '/docs/quickstart'
      fullPath: '/docs/quickstart'
      preLoaderRoute: typeof AppDocsQuickstartRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/changelog': {
      id: '/_app/docs/changelog'
      path: '/docs/changelog'
      fullPath: '/docs/changelog'
      preLoaderRoute: typeof AppDocsChangelogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/api': {
      id: '/_app/docs/api'
      path: '/docs/api'
      fullPath: '/docs/api'
      preLoaderRoute: typeof AppDocsApiRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cli/authorize': {
      id: '/_app/cli/authorize'
      path: '/cli/authorize'
      fullPath: '/cli/authorize'
      preLoaderRoute: typeof AppCliAuthorizeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/webhooks/': {
      id: '/_app/settings/webhooks/'
      path: '/webhooks'
      fullPath: '/settings/webhooks/'
      preLoaderRoute: typeof AppSettingsWebhooksIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/logs/': {
      id: '/_app/settings/logs/'
      path: '/logs'
      fullPath: '/settings/logs/'
      preLoaderRoute: typeof AppSettingsLogsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/origins/$siteUuid/': {
      id: '/_app/origins/$siteUuid/'
      path: '/origins/$siteUuid'
      fullPath: '/origins/$siteUuid/'
      preLoaderRoute: typeof AppOriginsSiteUuidIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/webhooks/new': {
      id: '/_app/settings/webhooks/new'
      path: '/webhooks/new'
      fullPath: '/settings/webhooks/new'
      preLoaderRoute: typeof AppSettingsWebhooksNewRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/logs/$auditId': {
      id: '/_app/settings/logs/$auditId'
      path: '/logs/$auditId'
      fullPath: '/settings/logs/$auditId'
      preLoaderRoute: typeof AppSettingsLogsAuditIdRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/webhooks/$uuid/edit': {
      id: '/_app/settings/webhooks/$uuid/edit'
      path: '/webhooks/$uuid/edit'
      fullPath: '/settings/webhooks/$uuid/edit'
      preLoaderRoute: typeof AppSettingsWebhooksUuidEditRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/webhooks/$uuid/deliveries': {
      id: '/_app/settings/webhooks/$uuid/deliveries'
      path: '/webhooks/$uuid/deliveries'
      fullPath: '/settings/webhooks/$uuid/deliveries'
      preLoaderRoute: typeof AppSettingsWebhooksUuidDeliveriesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/origins/$siteUuid/pages/$pageUuid': {
      id: '/_app/origins/$siteUuid/pages/$pageUuid'
      path: '/origins/$siteUuid/pages/$pageUuid'
      fullPath: '/origins/$siteUuid/pages/$pageUuid'
      preLoaderRoute: typeof AppOriginsSiteUuidPagesPageUuidRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsDangerRoute: typeof AppSettingsDangerRoute
  AppSettingsIntegrationsRoute: typeof AppSettingsIntegrationsRoute
  AppSettingsKeysRoute: typeof AppSettingsKeysRoute
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsWorkspaceRoute: typeof AppSettingsWorkspaceRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsLogsAuditIdRoute: typeof AppSettingsLogsAuditIdRoute
  AppSettingsWebhooksNewRoute: typeof AppSettingsWebhooksNewRoute
  AppSettingsLogsIndexRoute: typeof AppSettingsLogsIndexRoute
  AppSettingsWebhooksIndexRoute: typeof AppSettingsWebhooksIndexRoute
  AppSettingsWebhooksUuidDeliveriesRoute: typeof AppSettingsWebhooksUuidDeliveriesRoute
  AppSettingsWebhooksUuidEditRoute: typeof AppSettingsWebhooksUuidEditRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsDangerRoute: AppSettingsDangerRoute,
  AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,
  AppSettingsKeysRoute: AppSettingsKeysRoute,
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsWorkspaceRoute: AppSettingsWorkspaceRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsLogsAuditIdRoute: AppSettingsLogsAuditIdRoute,
  AppSettingsWebhooksNewRoute: AppSettingsWebhooksNewRoute,
  AppSettingsLogsIndexRoute: AppSettingsLogsIndexRoute,
  AppSettingsWebhooksIndexRoute: AppSettingsWebhooksIndexRoute,
  AppSettingsWebhooksUuidDeliveriesRoute:
    AppSettingsWebhooksUuidDeliveriesRoute,
  AppSettingsWebhooksUuidEditRoute: AppSettingsWebhooksUuidEditRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppDebugDataRoute: typeof AppDebugDataRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppCliAuthorizeRoute: typeof AppCliAuthorizeRoute
  AppDocsApiRoute: typeof AppDocsApiRoute
  AppDocsChangelogRoute: typeof AppDocsChangelogRoute
  AppDocsQuickstartRoute: typeof AppDocsQuickstartRoute
  AppDocsSdksRoute: typeof AppDocsSdksRoute
  AppDocsWebhooksRoute: typeof AppDocsWebhooksRoute
  AppMonitorsNewRoute: typeof AppMonitorsNewRoute
  AppDocsIndexRoute: typeof AppDocsIndexRoute
  AppHelpIndexRoute: typeof AppHelpIndexRoute
  AppMonitorsIndexRoute: typeof AppMonitorsIndexRoute
  AppOriginsIndexRoute: typeof AppOriginsIndexRoute
  AppOriginsSiteUuidIndexRoute: typeof AppOriginsSiteUuidIndexRoute
  AppOriginsSiteUuidPagesPageUuidRoute: typeof AppOriginsSiteUuidPagesPageUuidRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDebugDataRoute: AppDebugDataRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppCliAuthorizeRoute: AppCliAuthorizeRoute,
  AppDocsApiRoute: AppDocsApiRoute,
  AppDocsChangelogRoute: AppDocsChangelogRoute,
  AppDocsQuickstartRoute: AppDocsQuickstartRoute,
  AppDocsSdksRoute: AppDocsSdksRoute,
  AppDocsWebhooksRoute: AppDocsWebhooksRoute,
  AppMonitorsNewRoute: AppMonitorsNewRoute,
  AppDocsIndexRoute: AppDocsIndexRoute,
  AppHelpIndexRoute: AppHelpIndexRoute,
  AppMonitorsIndexRoute: AppMonitorsIndexRoute,
  AppOriginsIndexRoute: AppOriginsIndexRoute,
  AppOriginsSiteUuidIndexRoute: AppOriginsSiteUuidIndexRoute,
  AppOriginsSiteUuidPagesPageUuidRoute: AppOriginsSiteUuidPagesPageUuidRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthSsoCallbackRoute: typeof AuthSsoCallbackRoute
  AuthTwoFactorRoute: typeof AuthTwoFactorRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  AuthVerifySignInRoute: typeof AuthVerifySignInRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthSsoCallbackRoute: AuthSsoCallbackRoute,
  AuthTwoFactorRoute: AuthTwoFactorRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  AuthVerifySignInRoute: AuthVerifySignInRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  UiSandboxRoute: UiSandboxRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
